// The standard "this is prototype data" warn card. Copy stays with the
// call site; a screen that renders fixture data must always show one.

import type { ReactNode } from "react";

export function FixtureNotice({ children }: { children: ReactNode }) {
  return (
    <div
      className="cc-card"
      style={{ padding: "10px 18px", color: "var(--warn-600)", marginBottom: 12 }}
    >
      {children}
    </div>
  );
}
